export default __webpack_public_path__ + "static/media/Slide6.c8449200.jpg";